export enum SortOptions {
    AZ = 1,
    RELEVANCY = 2,
    FAVORITES = 3,
    RECENT = 4
}
